module.exports = __webpack_public_path__ + "static/hyperv_43.25c3e1ac.png";